module.exports = __webpack_public_path__ + "img/thumbnail.b72039cf.png";